export const FilterIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
        >
            <path
                fill="#73A5D8"
                d="M50.43 10.391a2.668 2.668 0 0 1 2.634 3.06l-.035.19c-.097.435-.303.84-.6 1.177l-4.02 4.593-1.525-1.295 4.04-4.615.004-.003a.668.668 0 0 0-.405-1.1l-.095-.007H14.166l-.096.007a.666.666 0 0 0-.462 1.024l.058.076.002.003 14.8 16.906a2 2 0 0 1 .495 1.317v17.813a1 1 0 0 0 1.447.894l4.667-2.333a1 1 0 0 0 .553-.894v-15.48a2 2 0 0 1 .495-1.317l4.97-5.679 1.524 1.295-4.99 5.701v15.48a3 3 0 0 1-1.657 2.683l-4.667 2.333c-1.995.998-4.342-.453-4.342-2.683V31.724l-14.8-16.906a2.667 2.667 0 0 1-.599-1.178l-.035-.188a2.668 2.668 0 0 1 2.634-3.06H50.43Z"
            />
        </svg>
    );
};
